// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"2cc0dd20","511":"6c7cc0d8"}[chunkId] + ".chunk.js";
};